// import "./LifeatCrest.css";
// import React, { useRef, useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import Modal4 from "./Modal4";

// const LifeatCrest = () => {
//   const modalData = [
//     {
//       img: "/assets/lifeatcrest/lifeimg1.jpg",
//     },
//     {
//       img: "/assets/lifeatcrest/lifeimg2.jpg",
//     },
//     {
//       img: "/assets/lifeatcrest/lifeimg3.jpg",
//     },
//     {
//       img: "/assets/lifeatcrest/lifeimg4.jpg",
//     },
//     {
//       img: "/assets/lifeatcrest/lifeimg5.jpg",
//     },
//   ];
//   const [modals, setModals] = useState([]);

//   useEffect(() => {
//     setModals(modalData.map((modal) => ({ ...modal, isOpen: false })));
//   }, []);

//   const setModalState = (index, isOpen) => {
//     const updatedModals = [...modals];
//     updatedModals[index].isOpen = isOpen;
//     setModals(updatedModals);
//   };

//   const openModal = (index) => {
//     setModalState(index, true);
//   };

//   const closeModal = (index) => {
//     setModalState(index, false);
//   };

//   return (
//     <div>
//       <div className="hero_img lifeatcrest_mobile_img">
//         <img src="	https://www.crestdigitel.com/wp-content/uploads/2023/04/crest_life_banner.png" alt="" />
//       <div className="hero_title hero_title_clr">Life at Crest</div>

//       </div>
//       <div className="container2">
//         <div className="portp_div2 container">
//           <div className="portp_div21  ">
//             <h2>Enabled Workforce</h2>
//             <p>
//               Our culture is built on the pillars of Care, Connect and
//               Collaboration and is supported by a solid value system and
//               governance, which serve as a unifying principle in how we operate.
//               With equity of opportunity for all, we support co-creating an
//               inclusive workplace. Our greatest asset is our people and our
//               high-trust, high-performance culture is built on the principles of
//               letting employees be who they are, taking a transparent, fair
//               approach and connecting with people at all levels.
//             </p>
//             <p>
//               Safety First is our company’s mantra, reinforcing our dedication
//               to providing our employees with a safe and healthy working
//               environment. We work hard to create an environment at work where
//               everyone feels valued and inspired to express their uniqueness and
//               work together for the common goal of the organization.
//             </p>
//           </div>
//           <div className="portp_div31">
//             <img src="/assets/lifeatcrest/lifeatcrestimg2.jpg" alt="" />
//           </div>
//         </div>

//         <div className="portp_div2 container life_flex">
//           <div className="portp_div31">
//             <img src="/assets/lifeatcrest/lifeatcrestimg3.jpg" alt="" />
//           </div>
//           <div className="portp_div21  ">
//             <h2>Diversity, Equity and Inclusion</h2>
//             <p>
//               Our aim at Crest Digitel is to co-create an inclusive workplace
//               where everyone has the same access to opportunities. As market
//               leaders in the Digital Infrastructure space, we also have a
//               responsibility to include and diversify. We work to break down our
//               biases, change our thought processes and ensure voices are heard
//               and acted on.
//             </p>
//             <p>
//               At our organization, each employee is valued for their unique
//               skills and experience and is empowered to contribute to business
//               success. An employee hired by us definitely brings something to
//               the table that everyone can learn from and contribute to. As an
//               organisation, it matters less where we came from or what race,
//               ethnicity, religion or culture we represent; we focus on
//               developing the skills and competencies we need to succeed.
//             </p>
//           </div>
//         </div>
//         <div>
//           <h4 className="life_heading">A glimpse into our world</h4>
//           <div className="life_div1">
//             <div className="life_div11">
//               <Link onClick={() => openModal(0)}>
//                 <img src="/assets/lifeatcrest/lifeatcrestimg4.jpg" alt="" />
//               </Link>
//               <Link onClick={() => openModal(1)}>
//                 <img src="/assets/lifeatcrest/lifeatcrestimg5.jpg" alt="" />
//               </Link>
//               <Link onClick={() => openModal(2)}>
//                 <img src="/assets/lifeatcrest/lifeatcrestimg6.jpg" alt="" />
//               </Link>
//             </div>
//             <div className="life_div11">
//             <Link onClick={() => openModal(3)}>
//                 <img src="/assets/lifeatcrest/lifeatcrestimg7.jpg" alt="" />
//               </Link>
//               <Link onClick={() => openModal(4)}>
//                 <img src="/assets/lifeatcrest/lifeatcrestimg8.jpg" alt="" />
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//       {modals.map(
//         (modal, index) =>
//           modal.isOpen && (
//             <Modal4
//               key={index}
//               closeModal={() => closeModal(index)}
//               img={modal.img}
//               title={modal.title}
//               name={modal.name}
//               about={modal.about}
//             />
//           )
//       )}
//     </div>
//   );
// };

// export default LifeatCrest;

import "./LifeatCrest.css";
import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal4 from "./Modal4";

const LifeatCrest = () => {
  const modalData = [
    {
      img: "/assets/lifeatcrest/lifeimg1.jpg",
    },
    {
      img: "/assets/lifeatcrest/lifeimg2.jpg",
    },
    {
      img: "/assets/lifeatcrest/lifeimg3.jpg",
    },
    {
      img: "/assets/lifeatcrest/lifeimg4.jpg",
    },
    {
      img: "/assets/lifeatcrest/lifeimg5.jpg",
    },
  ];
  const [modals, setModals] = useState([]);

  useEffect(() => {
    setModals(modalData.map((modal) => ({ ...modal, isOpen: false })));
  }, []);

  const setModalState = (index, isOpen) => {
    const updatedModals = [...modals];
    updatedModals[index].isOpen = isOpen;
    setModals(updatedModals);
  };

  const openModal = (index) => {
    setModalState(index, true);
  };

  const closeModal = (index) => {
    setModalState(index, false);
  };

  return (
    <div>
      <div className="hero_img lifeatcrest_mobile_img">
      <img src="/assets/crest_life_banner.png" alt="" />
        <div className="hero_title hero_title_clr">Life at Crest</div>
      </div>
      <div className="container2">
        <div className="portp_div2 container">
          <div className="portp_div21  ">
            <h2>Enabled Workforce</h2>
            <p>
              Our culture is built on the pillars of Care, Connect and
              Collaboration and is supported by a solid value system and
              governance, which serve as a unifying principle in how we operate.
              With equity of opportunity for all, we support co-creating an
              inclusive workplace. Our greatest asset is our people and our
              high-trust, high-performance culture is built on the principles of
              letting employees be who they are, taking a transparent, fair
              approach and connecting with people at all levels.
            </p>
            <p>
              Safety First is our company’s mantra, reinforcing our dedication
              to providing our employees with a safe and healthy working
              environment. We work hard to create an environment at work where
              everyone feels valued and inspired to express their uniqueness and
              work together for the common goal of the organization.
            </p>
          </div>
          <div className="portp_div31">
            <img src="/assets/lifeatcrest/lifeatcrestimg2.jpg" alt="" />
          </div>
        </div>

        <div className="portp_div2 container life_flex">
          <div className="portp_div31">
            <img src="/assets/lifeatcrest/lifeatcrestimg3.jpg" alt="" />
          </div>
          <div className="portp_div21  ">
            <h2>Diversity, Equity and Inclusion</h2>
            <p>
              Our aim at Crest Digitel is to co-create an inclusive workplace
              where everyone has the same access to opportunities. As market
              leaders in the Digital Infrastructure space, we also have a
              responsibility to include and diversify. We work to break down our
              biases, change our thought processes and ensure voices are heard
              and acted on.
            </p>
            <p>
              At our organization, each employee is valued for their unique
              skills and experience and is empowered to contribute to business
              success. An employee hired by us definitely brings something to
              the table that everyone can learn from and contribute to. As an
              organisation, it matters less where we came from or what race,
              ethnicity, religion or culture we represent; we focus on
              developing the skills and competencies we need to succeed.
            </p>
          </div>
        </div>
        <div>
          <h4 className="life_heading">A glimpse into our world</h4>
          <div className="life_center">
          <div className="life_div1 life_div11">
            <div className=" life_div11">
              <Link onClick={() => openModal(0)}>
                <img src="/assets/lifeatcrest/lifeatcrestimg4.jpg" alt="" />
              </Link>
            </div>
            <div className=" life_div11">
              <Link onClick={() => openModal(1)}>
                <img src="/assets/lifeatcrest/lifeatcrestimg5.jpg" alt="" />
              </Link>
            </div>
            <div className=" life_div11">
              <Link onClick={() => openModal(2)}>
                <img src="/assets/lifeatcrest/lifeatcrestimg6.jpg" alt="" />
              </Link>
            </div>
            <div className=" life_div11">
              <Link onClick={() => openModal(3)}>
                <img src="/assets/lifeatcrest/lifeatcrestimg7.jpg" alt="" />
              </Link>
            </div>
            <div className=" life_div11">
              <Link onClick={() => openModal(4)}>
                <img src="/assets/lifeatcrest/lifeatcrestimg8.jpg" alt="" />
              </Link>
            </div>
          </div>
          </div>

        </div>
      </div>
      {modals.map(
        (modal, index) =>
          modal.isOpen && (
            <Modal4
              key={index}
              closeModal={() => closeModal(index)}
              img={modal.img}
              title={modal.title}
              name={modal.name}
              about={modal.about}
            />
          )
      )}
    </div>
  );
};

export default LifeatCrest;
